export default {
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: '输入密码'
    }
  },
  data() {
    return {
      ishaspws: false,
      onImg: require('@/assets/image/ic_yanjing_see_on.png'),
      offImg: require('@/assets/image/ic_yanjing_see_off.png')
    };
  },
  methods: {
    setInputValue(val) {
      this.$emit('input', val);
    },
    handleSeePaw() {
      this.ishaspws = !this.ishaspws;
    }
  }
};